"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_KEY_HEADER_NAME = exports.AnalyticsParentAppToTargetSystemMap = exports.AnalyticsTargetSystem = exports.AnalyticsParentApp = void 0;
var AnalyticsParentApp;
(function (AnalyticsParentApp) {
    AnalyticsParentApp["OwnFleet"] = "own-fleet";
    AnalyticsParentApp["DeliveryHub"] = "delivery-hub";
})(AnalyticsParentApp || (exports.AnalyticsParentApp = AnalyticsParentApp = {}));
var AnalyticsTargetSystem;
(function (AnalyticsTargetSystem) {
    AnalyticsTargetSystem[AnalyticsTargetSystem["OwnFleet"] = 0] = "OwnFleet";
    AnalyticsTargetSystem[AnalyticsTargetSystem["DeliveryHub"] = 1] = "DeliveryHub";
})(AnalyticsTargetSystem || (exports.AnalyticsTargetSystem = AnalyticsTargetSystem = {}));
exports.AnalyticsParentAppToTargetSystemMap = new Map([
    [AnalyticsParentApp.OwnFleet, AnalyticsTargetSystem.OwnFleet],
    [AnalyticsParentApp.DeliveryHub, AnalyticsTargetSystem.DeliveryHub]
]);
exports.API_KEY_HEADER_NAME = 'x-api-key';
//# sourceMappingURL=common.js.map